<template>
  <el-dialog
            title="Clone Company"
            :visible.sync="innerValue"
            width="530px"
            height="100%"
            :close-on-click-modal=false
            :close-on-press-escape=false
            v-loading="loading"
  >
    <el-card class="box-card">
      <el-form>
        <el-form-item label="Remote server url">
          <el-input v-model="remoteServerUrl" placeholder="https://..." :disabled="availableRemoteCompanies.length>0"></el-input>
        </el-form-item>
        <el-form-item label="Remote server Superuser name">
          <el-input v-model="remoteServerSUname" placeholder="admin" :disabled="availableRemoteCompanies.length>0"></el-input>
        </el-form-item>

        <el-form-item label="Remote server Superuser password">
          <el-input v-model="remoteServerSUpwd" placeholder="password" type="password" :disabled="availableRemoteCompanies.length>0"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="verifySUcredentials" :disabled="availableRemoteCompanies.length>0">Apply credentials</el-button>
        </el-form-item>
      </el-form>
    </el-card>

        <el-card class="u-mt4" v-if="availableRemoteCompanies.length">

          <div>
            <span>Company Id to clone</span>
            <el-select v-model="clonedCompanyId">
              <el-option  :selected="clonedCompanyId==company.id"
                          :disabled="isCompanyDisabled(company.id)"
                          v-for="company in availableRemoteCompanies"
                          :value="company.id"
                          :label="company.name"
                          :key="company.id"></el-option>
            </el-select>
          </div>

          <el-checkbox v-model="copyCompanySensitiveSetup" class="u-mt2 display-block u-text--danger">Clone sensitive company setup - URL/keys etc (not recommended)</el-checkbox>
          <el-checkbox v-model="cloneInsureds" class="u-mt2 display-block u-text--danger">Clone insureds (not recommended)</el-checkbox>
          <el-checkbox v-model="cloneSettings" class="u-mt2 display-block">Clone settings</el-checkbox>
          <el-checkbox v-model="cloneContent" class="u-mt2 display-block">Clone content</el-checkbox>
          <el-checkbox v-model="cloneTemplates" class="u-mt2 display-block">Clone templates (email, in-app, sms messaging)</el-checkbox>
          <el-checkbox v-model="cloneColors" class="u-mt2 display-block">Clone colors (SCSS tweaked constants)</el-checkbox>
          <el-checkbox v-model="cloneImages" class="u-mt2 display-block">Clone images (appearance)</el-checkbox>
    </el-card>

    <div class="u-mt4" v-if="availableRemoteCompanies.length">
      <el-button @click="performClone" type="danger" class="display-block" :disabled="!clonedCompanyId">performClone</el-button>
      <span class="u-text--danger word-break-keep-all">Cloning could take up to minute. This depends on customized data pool and especially on images</span>
    </div>

  </el-dialog>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import {axiosWrapper} from '@/shared/api.utils'
import config from '@/config'
import axios from 'axios'


export default {
  name: 'ba-approval-dialog',
  components: {},
  props: {
    value: {type: Boolean},
  },
  watch: {
    value: {
      handler (value) {
        this.innerValue = value
      },
      immediate: true
    },
    innerValue: {
      handler (innerValue) {
        this.$emit('input', innerValue)
        this.$emit('change', innerValue)
      },
      immediate: true
    },
  },
  data () {
    return {
      innerValue: false,
      remoteServerUrl: 'https://dev.admin.briteapps.com',
      remoteServerSUname: '',
      remoteServerSUpwd: '',
      copyCompanySensitiveSetup: false,
      clonedCompanyId: null,
      cloneInsureds: false,
      cloneSettings: true,
      cloneContent: true,
      cloneTemplates: true,
      cloneColors: true,
      cloneImages: true,
      availableRemoteCompanies: [],
      selectedCompany: null,
      loading: false,
    }
  },
  methods: {
    ...mapActions('login', ['init']),
    ...mapActions('shared', ['loadHealthcheck']),
    async performRemoteSuLogin () {
      const uninterceptedAxiosInstance = axios.create()
      return axiosWrapper(uninterceptedAxiosInstance.post(this.remoteServerUrl + '/login_as_company_staff/', {
        username: this.remoteServerSUname,
        password: this.remoteServerSUpwd,
      }))
    },
    async verifySUcredentials () {
      this.loading = true
      try {
        let resp = await this.performRemoteSuLogin()
        if (resp.data.is_superuser) {
          this.availableRemoteCompanies = resp.data.available_companies
          this.$alert(
            `Valid credentials`,
            'Valid credentials',
          )
        } else {
          this.$alert(
            `Provided credentials does not belong to superuser, cloning impossible`,
            'Wrong role',
          )
        }
      } catch (error) {
        this.$alert(
          `Failed to perform action. ${error.response.message}`,
          'Wrong credentials',
        )
      }
      this.loading = false
    },
    async performClone () {
      this.loading = true
      let getLoginData
      try {
        getLoginData = await this.performRemoteSuLogin()
        console.log(getLoginData)
      } catch (error) {
        this.$alert(
          `Failed to perform action. ${error.response.message}`,
          'Failed to clone',
        )
        this.loading = false
        return
      }
      if (!getLoginData.data.is_superuser) {
        this.$alert(
          `Provided credentials does not belong to superuser, cloning impossible`,
          'Wrong role',
        )
        this.loading = false
        return
      }
      let remoteToken = getLoginData.token

      try {
        await axiosWrapper(axios.post(
          `${config.url}/copy-company/${this.clonedCompanyId}`,
          {
            remote_server_url: this.remoteServerUrl,
            remote_server_token: `Bearer ${remoteToken}`,
            copy_company_sensitive_setup: this.copyCompanySensitiveSetup,
            insureds: this.cloneInsureds,
            settings: this.cloneSettings,
            content: this.cloneContent,
            templates: this.cloneTemplates,
            colors: this.cloneColors,
            images: this.cloneImages
          }
        ))
        this.$alert(
          `Cloning successful`,
          'Cloning successful',
        )
      } catch (error) {
        this.$alert(
          `There was a failure during cloning. ${error.response.message}`,
          'Failed to clone',
        )
      }
      await this.init() // perform company refresh via carrier-user retrieval
      this.loadHealthcheck() // don't wait for Healthchecks
      this.clonedCompanyId = null
      this.loading = false
    }
  },
  computed: {
    ...mapGetters('shared', ['availableCompanies']),
    isCompanyDisabled: function () {
      return (companyId) => {
        return Boolean(this.availableCompanies.find(cmp => cmp.id ===companyId))
      }
    }
  }
}
</script>
